import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downloads-page',
  templateUrl: './downloads-page.component.html',
  styleUrls: ['./downloads-page.component.scss']
})
export class DownloadsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
